import { Component } from '@angular/core';
import {
	Data, DataLoaderService, Subscription, ResetService,
	PriceCalculationService, ProgressBarService
} from '../expert-service-call.index';
import * as _ from 'lodash';

@Component({
	selector: 'expert-trim-options',
	templateUrl: './expert-trim.template.html',
	styleUrls: ['./expert-trim.component.css']
})
export class ExpertTrimOptions {
	public trimOptions = [];
	public trimKeyValues: String[] = [];
	public expTrim: Data[];
	public selected: Data[] = [];
	public retained = [];
	public subscription: Subscription;
	public expertTrimOptions;
	public temp: Data[];

	constructor(private dataLoaderService: DataLoaderService,
		private priceCalculationService: PriceCalculationService,
		private resetService: ResetService, private progressService: ProgressBarService) {
		this.trimOptions = this.dataLoaderService.data.trim;
	}
	ngOnInit() {
		if(this.trimOptions.length == 0 ){
			this.dataLoaderService.flagDictionary.noTrimOptions = true;
		}
		// //Retention Service
		this.subscription = this.priceCalculationService.notifyObservableNormalComp$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "normalTrim") {
				if (selectedOption.data[0] != undefined) {
					this.selected = selectedOption.data[0].code;
					if(!this.dataLoaderService.flagDictionary.undoActivatedForTrim){
						this.dataLoaderService.previousTrimExp = selectedOption.data[0].code;
					}
				} else {
					if (selectedOption.data != undefined) {
						let temp = [];
						temp.push(selectedOption.data);
						this.selected = temp[0].code;
						if(!this.dataLoaderService.flagDictionary.undoActivatedForTrim){
							this.dataLoaderService.previousTrimExp = selectedOption.data[0] && selectedOption.data[0].code;
						}
					} else {
						this.selected = [];
						if(!this.dataLoaderService.flagDictionary.undoActivatedForTrim){
							this.dataLoaderService.previousTrimExp = selectedOption.data[0].code;
						}
					}
				}
				this.progressService.progressBarValidation();
			}
		});

		// for undo alternative option
		
		this.priceCalculationService.notifyObservableExpertCompLastItem$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "expertTrim") {
				if (selectedOption.data[0] != undefined) {
					this.selected = selectedOption.data[0].code;
					this.dataLoaderService.previousTrimExp = selectedOption.data[0].code;
				} else {
					this.selected = [];
					this.dataLoaderService.previousTrimExp = [];
				}
				
				this.dataLoaderService.flagDictionary.undoActivatedForTrim= false;
				this.dataLoaderService.flagDictionary.undoActivated= false;
				
				this.progressService.progressBarValidation();
				
			}
		});
		// Undo - End
		//On load	
		let trim;
		this.trimOptions.forEach(element => {
			if (element.selected === true) {
				trim = element;
				this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalTrim", data: [trim] });
			}
		});


		//Reset
		this.subscription = this.resetService.notifyObservable$.subscribe((res) => {
			this.selected = this.resetService.expTrimCodes;

			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertTrim", data: this.resetService.expTrim });
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalTrim", data: this.resetService.expTrim });
			this.priceCalculationService.expertModePriceCalculation();

		});
	}

	ngAfterContentChecked() {
		this.trimKeyValues = [];

		for (let index = 0; index < this.trimOptions.length; index++) {
			if (this.trimOptions[index].selected === false) {
				this.trimKeyValues.push(((this.trimOptions[index].code + " - " + this.trimOptions[index].description)));
			}

		}

		for (let j = 0; j < this.trimKeyValues.length; j++) {
			if (this.selected != undefined) {
				for (let i = 0; i < this.selected.length; i++) {
					let item = this.trimKeyValues[j].substring(0, this.trimKeyValues[j].indexOf(' - '));
					let temp = this.selected[i] + "";
					if (item === temp) {
						this.trimKeyValues.splice(Number(j), 1);
					}
				}
			}
		}
	}

	clearOptions() {
		this.expertTrimOptions = null;
	}

	// Set flags to activate undo 
	undoActivate(){
		// for undo operation in alternative screen -start 
		this.dataLoaderService.flagDictionary.undoActivatedForTrim= true;
		this.dataLoaderService.flagDictionary.undoActivated= true;
		// for undo operation in alternative screen -end
	}
	//adds selected trim 
	onTrimOptionClick(item) {
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);
		this.undoActivate() //undo activate
		this.dataLoaderService.flagDictionary.closeFlag = false;
		let trimCode;
		trimCode = item.substr(0, 3);
		let selcFacForRem = [];
		for (let k in this.trimOptions) {
			if (this.trimOptions[k].selected) {
				selcFacForRem = this.trimOptions[k];
				// if (this.trimOptions[k].code !== trimCode) {
				// 	this.dataLoaderService.expertRemovedCodes.push(this.trimOptions[k]);
				// }
			}
		}
		this.priceCalculationService.notifyExpertCompForRemoved({ fromComponent: "expertTrim", data: selcFacForRem });
		// this.dataLoaderService.expAdd.push(trimCode);
		this.dataLoaderService.flagDictionary.expertValidateFlag = true;
		this.dataLoaderService.flagDictionary.expertvalidated = false;
		this.selected = trimCode;
		for (let i in this.trimOptions) {
			if (this.trimOptions[i].code === trimCode) {
				this.expTrim = this.trimOptions[i];
				this.trimOptions[i].selected = true;
			} else {
				this.trimOptions[i].selected = false;
			}

		}
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertTrim", data: [this.expTrim] });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalTrim", data: [this.expTrim] });
		this.priceCalculationService.expertModePriceCalculation();

		this.progressService.progressBarValidation();
	}

	// removes the selected trim
	deleteSelExpTrim(item) {
		this.undoActivate() //undo activate
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);
		this.dataLoaderService.flagDictionary.closeFlag = false;
		let trimCode;
		trimCode = item.substr(0, 3);
		this.selected = [];
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertTrim", data: [] });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalTrim", data: [] });
		let selcFacForRem = [];
		for (let k in this.trimOptions) {
			if (this.trimOptions[k].selected) {
				selcFacForRem = this.trimOptions[k];
			}
		}
		this.priceCalculationService.notifyExpertCompForRemoved({ fromComponent: "expertTrim", data: [selcFacForRem] });

		for (let i in this.trimOptions) {
			if (this.trimOptions[i].code === trimCode) {
				// this.dataLoaderService.expertRemovedCodes.push(this.trimOptions[i]);
				this.trimOptions[i].selected = false;
				this.dataLoaderService.flagDictionary.expertValidateFlag = true;
				// this.dataLoaderService.flagDictionary.expertvalidated = false;
			}
		}
		this.priceCalculationService.expertModePriceCalculation();

		this.progressService.progressBarValidation();
	}
}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-trim/expert-trim.component.ts